/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementslastupdatedtooltip3Inputs */

const id_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set pencapaian ini terakhir diperbarui pada`)
};

const ms_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set pencapaian ini terakhir dikemas kini pada`)
};

const da_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette achievement-sæt blev sidst opdateret den`)
};

const de_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Errungenschaften-Set wurde zuletzt aktualisiert am`)
};

const en_us2_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This achievement set was last updated on`)
};

const es_es2_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este conjunto de logros se actualizó por última vez el`)
};

const es_mx2_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este conjunto de logros se actualizó por última vez el`)
};

const fil_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang achievement set na ito ay huling na-update noong`)
};

const fr_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet ensemble de succès a été mis à jour pour la dernière fois le`)
};

const it_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo set di risultati è stato aggiornato l'ultima volta il`)
};

const hu_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a teljesítménykészlet utoljára frissült:`)
};

const nl_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze prestatieset is voor het laatst bijgewerkt op`)
};

const no_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette prestasjonssettet ble sist oppdatert`)
};

const pl_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten zestaw osiągnięć został ostatnio zaktualizowany`)
};

const pt_br2_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este conjunto de conquistas foi atualizado pela última vez em`)
};

const pt_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este conjunto de conquistas foi atualizado pela última vez em`)
};

const ro_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acest set de realizări a fost actualizat ultima dată pe`)
};

const fi_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä saavutussarja päivitettiin viimeksi`)
};

const sv_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna prestationsuppsättning uppdaterades senast`)
};

const vi_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ thành tích này được cập nhật lần cuối vào`)
};

const tr_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu başarım seti en son şu tarihte güncellendi:`)
};

const cs_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato sada úspěchů byla naposledy aktualizována`)
};

const bg_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този набор от постижения е актуализиран последно на`)
};

const ru_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот набор достижений последний раз обновлялся`)
};

const uk_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей набір досягнень востаннє оновлено`)
};

const ar_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تحديث لمجموعة الإنجازات هذه كان في`)
};

const hi_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह उपलब्धि सेट अंतिम बार अपडेट किया गया था`)
};

const th_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุดความสำเร็จนี้ได้รับการอัปเดตล่าสุดเมื่อ`)
};

const ja_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この実績セットの最終更新日：`)
};

const zh_cn2_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此成就集合最后更新于`)
};

const zh_hant1_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此成就集合最後更新於`)
};

const ko_sandboxes_achievementslastupdatedtooltip3 = /** @type {(inputs: Sandboxes_Achievementslastupdatedtooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도전 과제 세트는 다음에 마지막으로 업데이트되었습니다`)
};

/**
* | output |
* | --- |
* | "This achievement set was last updated on" |
*
* @param {Sandboxes_Achievementslastupdatedtooltip3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementslastupdatedtooltip3 = /** @type {((inputs?: Sandboxes_Achievementslastupdatedtooltip3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementslastupdatedtooltip3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "ms") return ms_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "da") return da_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "de") return de_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "fil") return fil_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "fr") return fr_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "it") return it_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "hu") return hu_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "nl") return nl_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "no") return no_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "pl") return pl_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "pt") return pt_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "ro") return ro_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "fi") return fi_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "sv") return sv_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "vi") return vi_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "tr") return tr_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "cs") return cs_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "bg") return bg_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "ru") return ru_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "uk") return uk_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "ar") return ar_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "hi") return hi_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "th") return th_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "ja") return ja_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementslastupdatedtooltip3(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementslastupdatedtooltip3(inputs)
	return ko_sandboxes_achievementslastupdatedtooltip3(inputs)
});
export { sandboxes_achievementslastupdatedtooltip3 as "sandboxes.achievementsLastUpdatedTooltip" }